import DOMPurify from 'dompurify'

export const PROMO_SANITIZE_OPTIONS = { ADD_ATTR: ['target'] }

// Tags that render something by themselves, with no text around them.
const VISUAL_TAGS_SELECTOR =
  'img, picture, video, audio, iframe, svg, canvas, embed, object, hr, input, button'

// Non-breaking and zero-width spaces the email builder leaves behind.
const INVISIBLE_SPACES = /\u00a0|\u200b|\u200c|\u200d|\ufeff/g

/**
 * The email builder always sends an HTML skeleton (nested tables), even when
 * the user never wrote an email. Render the Promotional Email section only when
 * that skeleton actually holds visible content.
 *
 * @param {string} promoInfo raw `promoinfo` HTML coming from the API
 * @returns {boolean}
 */
export const hasPromoEmailContent = (promoInfo) => {
  if (typeof promoInfo !== 'string' || !promoInfo.trim()) {
    return false
  }

  const sanitizedHtml = DOMPurify.sanitize(promoInfo, PROMO_SANITIZE_OPTIONS)
  const { body } = new DOMParser().parseFromString(sanitizedHtml, 'text/html')

  body
    .querySelectorAll('script, style, template')
    .forEach((element) => element.remove())

  const hasText =
    body.textContent.replace(INVISIBLE_SPACES, ' ').trim().length > 0

  if (hasText || body.querySelector(VISUAL_TAGS_SELECTOR)) {
    return true
  }

  // Emails often carry images through `background` attributes or inline styles.
  return Array.from(body.querySelectorAll('[background], [style]')).some(
    (element) =>
      Boolean(element.getAttribute('background')?.trim()) ||
      /url\(/i.test(element.getAttribute('style') || '')
  )
}

export const handleAttachmentDownload = async (url) => {
  const downloadLink = document.createElement('a')

  downloadLink.href = url
  downloadLink.click()
}

export const downloadAllAttachments = (files) => {
  files.forEach(async (file) => {
    const downloadLink = document.createElement('a')

    downloadLink.href = file?.url
    downloadLink.click()
    await new Promise((resolve) => setTimeout(resolve, 5000)) // Pause for 1 second between downloads to avoid security mechanisms
  })
}
